import { createFileRoute } from '@tanstack/react-router';
import { Button, Card, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { notifyError } from '@/shared/lib/notify';
import { useAuth } from '@/app/providers/AuthProvider';
import { entraNellAzienda } from '@/features/tenants/switchTenant';
import { useState } from 'react';

export const Route = createFileRoute('/_auth/select-tenant')({ component: SelectTenantPage });

function SelectTenantPage() {
  const { associatedTenants, loginWithEnvelope } = useAuth();
  const [picking, setPicking] = useState<string | null>(null);

  /**
   * La stessa sequenza di `/switch-tenant`, non una copia: `entraNellAzienda`.
   *
   * Qui il difetto era identico — si rifaceva un `refresh()` col token vecchio, e il server
   * riportava all'azienda di partenza — e per un attimo le due schermate hanno avuto due
   * riparazioni diverse. Due copie della stessa sequenza divergono al primo ritocco, e questa
   * è la sequenza che decide **in quale azienda si entra**: non è un posto dove tenere due
   * versioni. Come là, si ricarica invece di navigare, e l'annuncio si legge dopo.
   */
  const onPick = async (tenantId: string, nome: string) => {
    setPicking(tenantId);
    try {
      await entraNellAzienda({ tenantId, nome, applica: loginWithEnvelope });
    } catch (err) {
      notifyError(err, 'Cambio azienda fallito');
    } finally {
      setPicking(null);
    }
  };

  return (
    <Stack>
      <Title order={2}>Seleziona la tua azienda</Title>
      <Text c="dimmed" size="sm">
        Hai accesso a più aziende. Scegli quella su cui vuoi lavorare ora.
      </Text>
      <SimpleGrid cols={{ base: 1, sm: 2 }}>
        {associatedTenants.map((t) => (
          <Card key={t.tenantId} withBorder padding="lg" radius="md">
            <Stack>
              <Text fw={600}>{t.name}</Text>
              <Button onClick={() => void onPick(t.tenantId, t.name ?? '')} loading={picking === t.tenantId}>
                Entra
              </Button>
            </Stack>
          </Card>
        ))}
      </SimpleGrid>
    </Stack>
  );
}
